import { render, staticRenderFns } from "./merchantDomain.vue?vue&type=template&id=286e16d8&scoped=true"
import script from "./merchantDomain.vue?vue&type=script&lang=js"
export * from "./merchantDomain.vue?vue&type=script&lang=js"
import style0 from "./merchantDomain.vue?vue&type=style&index=0&id=286e16d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286e16d8",
  null
  
)

export default component.exports